import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Optionally: You could hit your backend to fetch the Stripe session data here
    // e.g., using the session_id from URL: new URLSearchParams(window.location.search).get("session_id")
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>🎉 Payment Successful!</h1>
      <p>Your subscription has been activated.</p>
      <button
        onClick={() => navigate('/problems')}
        style={{
          marginTop: '1rem',
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          backgroundColor: '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        Start Solving Problems
      </button>
    </div>
  );
};

export default Success;
